import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    button: {
                        next: 'Järgmine',
                        addToCart: 'Lisa lipikule',
                        addRow: '+ lisa rida',
                        chooseNumbers: 'Vali number',
                        pliksPlaks: 'PLIKS PLAKS',
                        createSlip: 'Loo lipik'
                    },
                    texts: {
                        pliksPlaks: 'Pliks Plaks',
                        myCart: 'Minu lipikud',
                        slipCreated: 'Teie lipik on loodud',
                        showToClerk: 'Ostu sooritamiseks näita QR-koodi müüjale.',
                        drawCount: 'Loosimiste arv',
                        chooseNumber: 'Valige oma numbrid',
                        chooseNumbers: 'Valige oma numbrid',
                        more: 'jäänud',
                        ticket: 'pilet',
                        tickets: 'piletid',
                        addGame: 'Lisa mäng:'
                    }
                }
            },
            et: {
                translation: {
                    button: {
                        next: 'Edasi',
                        addToCart: 'Lisa korvi',
                        addRow: 'Lisa rida'
                    },

                    texts: {
                        showToClerk: 'Ostu sooritamiseks näita QR-koodi müüjale.'
                }

                }
            }
        }
    });

export default i18n;